import { Paper } from "@mui/material";
import PropTypes from "prop-types";

export default function MatchNetSideNavLayout({ children = <></> }) {
    return (
        <Paper
            style={{
                minWidth: "270px",
                maxWidth: "270px",
            }}
        >
            <div
                style={{
                    padding: "0px 10px",
                }}
            >
                {children}
            </div>
        </Paper>
    );
}

MatchNetSideNavLayout.propTypes = {
    children: PropTypes.object,
};
